import { api } from "../api";

/**
 * findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdGridResponse - Function that finds on database all vehicles with positions to list on grid response  
 * /vehicles/grid/{userId}/{customerId}/{departmentId}?ignoreDepartments={ignoreDepartments}
 * method GET  
 * @async-function
 */
const findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdGridResponse = async (token: string, userId: number, customerId: number, departmentId: number, ignoreDepartments: boolean = false, signal?: AbortSignal) => {
    const response = await api.get(
        `/vehicles/grid/${userId}/${customerId}/${departmentId}?ignoreDepartments=${ignoreDepartments}`, {
            signal,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    )
    return response;
};
export default findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdGridResponse;
